import classNames from 'classnames'
import { useRef } from 'react'
import ImageWithBasePath from './ImageWithBasePath'

export const HamburgerAnimation = ({ isClicked }) => {
  const individualClassNames = useRef(['hidden', 'rotate-45 transform', 'hidden'])

  return (
    <div className="relative flex h-[24px] w-[24px] flex-col items-center justify-center">
      <div className="relative flex h-[13px] w-[18] flex-col justify-between cursor-pointer">
        {individualClassNames?.current?.map((className, index) => {
          return (
            <div className="relative" key={index}>
              <ImageWithBasePath
                src="horizontalLine"
                width={18}
                height={2}
                className={classNames(
                  'flex rounded-xs transition-all duration-300',
                  isClicked && className
                )}
                alt="horizontal line"
              />
            </div>
          )
        })}
        <ImageWithBasePath
          src="horizontalLine"
          width={18}
          height={2}
          className={classNames(
            'rounded-xs transition-all duration-300',
            isClicked && '-rotate-45 transform'
          )}
          style={{ position: 'absolute', top: 0, bottom: 0, margin: 'auto 0' }}
          alt="horizontal line tilted"
        />
      </div>
    </div>
  )
}
